
<style>
  circle {
    stroke: #fff;
  }
  .title {
    font-weight: bold;
    font-family: Segoe UI,Helvetica Neue,Arial,sans serif;
    font-size: 16px;
    text-shadow:
      -2px -2px 0 #fff,
      2px -2px 0 #fff,
      -2px 2px 0 #fff,
      2px 2px 0 #fff;
  }
</style>

<div id="chart"></div>
